export default {"src":"/_next/static/media/profileBg.42112242.svg","height":240,"width":240,"blurWidth":0,"blurHeight":0};